import { defineComponent as _defineComponent } from 'vue'
import NjBtn from "@/components/vuetify-wrappers/NjButton.vue";
import { ApiService, SnackbarService } from "@/services";
import { useBriefcaseStore } from "@/pinia/briefcase";
import { BriefcaseActions, BriefcaseFolder, VignetteHelpers } from "@/types";
import { computed, getCurrentInstance, ref, watch } from "vue";
import BriefcaseFolderSelect from "@/components/selects/BriefcaseFolderSelect.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'BriefcaseFolderMoveDialog',
  setup(__props) {

const instance = getCurrentInstance();

const briefcaseStore = useBriefcaseStore();
briefcaseStore.meta.itemBeingMoved = null;
const isProfileSelected = computed(
  () => briefcaseStore.meta.itemBeingMoved !== null
);
watch(isProfileSelected, (val) => {
  if (val) {
    initializeSelectedFolders();
  }
});
/**
 * This is a computed value that returns all the folders in the briefcase
 * except for the ones that are hardcoded to be at the top of the list.
 * Remember that while using Vue 2 this isn't actually reactive.
 */
const briefcaseFolders = computed<BriefcaseFolder[]>(
  () => briefcaseStore.flatFoldersSorted
);
const getSelectedProfile = () => {
  return briefcaseStore.meta.itemBeingMoved;
};

const oldFolders = ref<number[]>([]);
const selectedFolders = ref<number[]>([briefcaseFolders.value[0].id]);
const initializeSelectedFolders = () => {
  const selectedProfile = getSelectedProfile();
  if (selectedProfile === null) return;

  selectedFolders.value = [];

  for (const briefcase of briefcaseFolders.value) {
    const briefcaseProfileIds: number[] = [];
    for (const item of briefcase.items) {
      briefcaseProfileIds.push(item.briefcaseItemId);
    }

    if (
      briefcaseProfileIds.indexOf(selectedProfile.briefcaseItemId) > -1 &&
      selectedFolders.value.indexOf(briefcase.id) < 0
    ) {
      selectedFolders.value.push(briefcase.id);
    }
    oldFolders.value = [...selectedFolders.value]; // Copy this array
  }
};
const foldersChanged = computed(() => {
  // Calculates if there is the folders have been changed.
  // const selectedFolders = new Set(this.selectedFolders);
  const _oldFolders = new Set(oldFolders.value);

  const _difference = new Set(selectedFolders.value);
  for (const elem of _oldFolders) {
    if (_difference.has(elem)) {
      _difference.delete(elem);
    } else {
      _difference.add(elem);
    }
  }

  return _difference.size > 0;
});

const getProfileDisplayName = () => {
  const profile = getSelectedProfile();
  return profile ? profile.preferredNameDisplay : "";
};
const moveProfiles = async (): Promise<void> => {
  const selectedProfile = getSelectedProfile();
  if (selectedProfile === null) return;

  let added = false;
  let removed = false;
  let result = false;

  // Removing profiles from folders
  for (const folder of oldFolders.value) {
    if (selectedFolders.value.indexOf(folder) < 0) {
      await ApiService.postBriefcaseToggle(
        [selectedProfile],
        BriefcaseActions.REMOVE,
        folder
      );
      removed = true;
      VignetteHelpers.Analytics.push({
        ["event"]: "briefcase-remove-items",
        ["custom.gtm.itemId"]: selectedProfile.id,
        ["custom.gtm.itemType"]: "Profile",
      });
    }
  }
  // Adding profiles to folders
  for (const folder of selectedFolders.value) {
    if (oldFolders.value.indexOf(folder) < 0) {
      result = await ApiService.postBriefcaseToggle(
        [selectedProfile],
        BriefcaseActions.ADD,
        folder
      );
      // Added message wouldn't be wrong. But won't be specific.
      if (result) {
        added = result;
      }

      VignetteHelpers.Analytics.push({
        ["event"]: "briefcase-add-items",
        ["custom.gtm.itemId"]: selectedProfile.id,
        ["custom.gtm.itemType"]: "Profile",
      });
    }
  }
  // Displaying snackbar
  let action = "";
  if (added && removed) {
    action = "moved";
  } else if (added) {
    action = "added";
  } else if (removed) {
    action = "removed";
  } else if (!result) {
    action = "failed";
  } else {
    return;
  }
  oldFolders.value = selectedFolders.value;
  if (!added) {
    SnackbarService.displaySnackbar(
      `You have too many profiles in your briefcase, try moving them around.`,
      "error",
      -1
    );
  } else {
    SnackbarService.displaySnackbar(
      `"${selectedProfile.preferredNameDisplay}" ${action}`,
      "primary",
      3000
    );
  }

  instance?.proxy?.$forceUpdate();
  briefcaseStore.meta.itemBeingMoved = null;
};

const updateFolders = (newFolders: number[]) => {
  selectedFolders.value = newFolders;
};

const closeDialog = () => {
  selectedFolders.value = [briefcaseFolders.value[0].id];
  briefcaseStore.meta.itemBeingMoved = null;
};

return { __sfc: true,instance, briefcaseStore, isProfileSelected, briefcaseFolders, getSelectedProfile, oldFolders, selectedFolders, initializeSelectedFolders, foldersChanged, getProfileDisplayName, moveProfiles, updateFolders, closeDialog, NjBtn, BriefcaseFolderSelect }
}

})